export default "__VITE_ASSET__BsXSYR4L__"